/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorMessage } from './aiTutorMessage';

/**
 * Response payload for GET history endpoint.
 */
export interface ChatHistory {
  messages?: AiTutorMessage[];
}
